export const COMMAND_ROOT = { kind: "root" } as const;

export type CommandPage =
  | typeof COMMAND_ROOT
  | { kind: "payroll-periods" }
  | {
      kind: "payroll-period";
      start: string;
      label: string;
      aiRunId: string | null;
      icmRunId: string | null;
    }
  | { kind: "payroll-sheets"; start: string; label: string; aiRunId: string }
  | {
      kind: "payroll-statements";
      start: string;
      label: string;
      icmRunId: string;
    }
  | { kind: "profitability" }
  | { kind: "ap-invoices" }
  | { kind: "ap-receipts" }
  | { kind: "ap-review" }
  | { kind: "help" };

export const commandPageLabel = (page: CommandPage): string | null => {
  switch (page.kind) {
    case "root":
      return null;
    case "payroll-periods":
      return "Payroll";
    case "payroll-period":
      return page.label;
    case "payroll-sheets":
      return "Sheets";
    case "payroll-statements":
      return "Statements";
    case "profitability":
      return "Job Costing";
    case "ap-invoices":
      return "Invoices";
    case "ap-receipts":
      return "Receipts";
    case "ap-review":
      return "Review";
    case "help":
      return "Help";
    default: {
      const exhaustive: never = page;
      return exhaustive;
    }
  }
};

export const commandPagePlaceholder = (page: CommandPage) => {
  switch (page.kind) {
    case "root":
      return "Search pages, actions and help";
    case "payroll-periods":
      return "Search pay periods";
    case "payroll-period":
      return "Search this period";
    case "payroll-sheets":
      return "Search sheets";
    case "payroll-statements":
      return "Search statements";
    case "profitability":
      return "Search reports";
    case "ap-invoices":
      return "Invoice number or vendor";
    case "ap-receipts":
      return "Receipt number or vendor";
    case "ap-review":
      return "Search the review queue";
    case "help":
      return "Search help";
    default: {
      const exhaustive: never = page;
      return exhaustive;
    }
  }
};

export const popCommandPage = (stack: readonly CommandPage[]) =>
  stack.length > 1 ? stack.slice(0, -1) : [...stack];
